"use client";

import { Minus, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Location() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.15
  });
  return <section data-section-id="3513" id="hier-finden-sie-uns" className="bg-background text-foreground py-20 md:py-[120px] px-6 md:px-12 lg:px-20">
      {}
      <div className="max-w-[1400px] mx-auto mb-12 md:mb-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="font-mono uppercase mb-6 tracking-[0.2em]" style={{
            color: "var(--primary)",
            fontSize: "11px"
          }}>
              UNSER STANDORT
            </p>
            <h2 className="font-default font-extrabold leading-[0.95] text-foreground text-4xl sm:text-5xl md:text-6xl lg:text-[72px]">
              BESUCHEN SIE <span style={{
              color: "var(--primary)"
            }}>UNS</span>
              <br />
              IN OLDENBURG<span style={{
              color: "var(--primary)"
            }}>.</span>
            </h2>
          </div>
          <p className="font-serif italic text-base md:text-right max-w-xs" style={{
          color: "var(--muted-foreground)"
        }}>
            Nach persönlicher Vereinbarung. Wir freuen uns auf Ihr Projekt.
          </p>
        </div>
      </div>

      {}
      <div className="max-w-[1400px] mx-auto relative">
        {}
        <div ref={ref} className={`relative w-full overflow-hidden shadow-2xl transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`} style={{
        height: "clamp(380px, 50vw, 600px)",
        backgroundColor: "hsl(0 0% 6%)"
      }}>
          {}
          {isVisible && <div className="absolute inset-0 pointer-events-none z-20" style={{
          background: "linear-gradient(90deg, transparent 0%, transparent 40%, hsla(43, 50%, 55%, 0.25) 50%, transparent 60%, transparent 100%)",
          animation: "chroma-scan 1.4s ease-out 0.2s 1 both"
        }} />}

          {}
          <div className="absolute inset-0">
            <svg width="100%" height="100%" viewBox="0 0 1400 600" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
              <rect width="1400" height="600" fill="hsl(0 0% 6%)" />
              {}
              <g stroke="hsl(0 0% 14%)" strokeWidth="2" fill="none">
                <path d="M0,180 L1400,160" />
                <path d="M0,340 L1400,360" />
                <path d="M0,480 L1400,460" />
                <path d="M220,0 L240,600" />
                <path d="M540,0 L520,600" />
                <path d="M860,0 L880,600" />
                <path d="M1160,0 L1140,600" />
              </g>
              {}
              <g stroke="hsl(0 0% 11%)" strokeWidth="1" fill="none">
                <path d="M0,80 L1400,90" />
                <path d="M0,260 L1400,250" />
                <path d="M0,420 L1400,430" />
                <path d="M0,560 L1400,550" />
                <path d="M100,0 L120,600" />
                <path d="M380,0 L400,600" />
                <path d="M680,0 L700,600" />
                <path d="M1000,0 L1020,600" />
                <path d="M1300,0 L1320,600" />
              </g>
              {}
              <g stroke="hsl(0 0% 13%)" strokeWidth="1.5" fill="none">
                <path d="M400,600 L900,0" />
              </g>
              {}
              <g fill="hsl(0 0% 8%)">
                <rect x="240" y="180" width="280" height="160" />
                <rect x="560" y="360" width="300" height="100" />
                <rect x="900" y="170" width="240" height="170" />
                <rect x="260" y="480" width="240" height="80" />
                <rect x="900" y="480" width="240" height="80" />
              </g>
              {}
              <g fill="hsl(0 0% 54%)" fontFamily="sans-serif" fontSize="11" letterSpacing="0.15em">
                <text x="60" y="120" opacity="0.6">HAUPTSTR</text>
                <text x="900" y="120" opacity="0.6">MARKTPLATZ</text>
                <text x="60" y="420" opacity="0.5">HAFEN</text>
                <text x="900" y="560" opacity="0.5">OLDENBURG</text>
                <text x="300" y="560" opacity="0.4">INNENSTADT</text>
              </g>
            </svg>
          </div>

          {}
          <div className="absolute z-10" style={{
          left: "52%",
          top: "48%",
          transform: "translate(-50%, -50%)"
        }}>
            <div className="relative flex items-center justify-center">
              {}
              <span className="absolute block" style={{
              width: "32px",
              height: "32px",
              border: "1px solid var(--primary)",
              animation: "chroma-pulse 3s ease-out infinite"
            }} />
              <span className="absolute block" style={{
              width: "32px",
              height: "32px",
              border: "1px solid var(--primary)",
              animation: "chroma-pulse 3s ease-out 1.5s infinite"
            }} />
              {}
              <span className="relative block" style={{
              width: "32px",
              height: "32px",
              backgroundColor: "var(--primary)",
              boxShadow: "0 0 24px hsla(43, 50%, 55%, 0.6)"
            }} />
            </div>
          </div>

          {}
          <div className="absolute top-5 right-5 flex flex-col gap-2 z-10">
            <Button variant="ghost" size="icon" aria-label="Zoom in" className="size-10 bg-background/40 backdrop-blur-md border hover:bg-background/60" style={{
            borderColor: "hsla(43, 50%, 55%, 0.5)"
          }}>
              <Plus className="size-4" style={{
              color: "var(--primary)"
            }} strokeWidth={2} />
            </Button>
            <Button variant="ghost" size="icon" aria-label="Zoom out" className="size-10 bg-background/40 backdrop-blur-md border hover:bg-background/60" style={{
            borderColor: "hsla(43, 50%, 55%, 0.5)"
          }}>
              <Minus className="size-4" style={{
              color: "var(--primary)"
            }} strokeWidth={2} />
            </Button>
          </div>

          {}
          <div className="hidden md:block absolute z-10" style={{
          left: "40px",
          bottom: "40px"
        }}>
            <div className="w-[360px] p-8 shadow-2xl" style={{
            backgroundColor: "hsla(0, 0%, 8%, 0.6)",
            backdropFilter: "blur(24px)",
            WebkitBackdropFilter: "blur(24px)",
            border: "1px solid hsla(43, 50%, 55%, 0.15)"
          }}>
              <p className="font-mono uppercase mb-5 tracking-[0.2em]" style={{
              color: "var(--primary)",
              fontSize: "11px"
            }}>
                ORVO WEB AGENTUR
              </p>
              <p className="font-default font-bold text-foreground leading-tight mb-5" style={{
              fontSize: "18px"
            }}>
                Digitales Büro
                <br />
                Oldenburg, Deutschland
                <br />
                26121
              </p>
              <div className="mb-5" style={{
              width: "24px",
              height: "1px",
              backgroundColor: "var(--primary)"
            }} />
              <p className="font-serif mb-6 leading-relaxed" style={{
              color: "var(--muted-foreground)",
              fontSize: "15px"
            }}>
                TERMINE NACH VEREINBARUNG — MO–FR 09:00–17:00
              </p>
              <Link to="/ContactPage" className="inline-flex items-center gap-2 font-mono uppercase tracking-[0.15em] underline underline-offset-4 hover:opacity-80 transition-opacity" style={{
              color: "var(--primary)",
              fontSize: "12px"
            }}>
                KONTAKT AUFNEHMEN →
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="md:hidden mt-6">
          <div className="w-full p-8 shadow-2xl" style={{
          backgroundColor: "hsla(0, 0%, 8%, 0.6)",
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          border: "1px solid hsla(43, 50%, 55%, 0.15)"
        }}>
            <p className="font-mono uppercase mb-5 tracking-[0.2em]" style={{
            color: "var(--primary)",
            fontSize: "11px"
          }}>
              ORVO WEB AGENTUR
            </p>
            <p className="font-default font-bold text-foreground leading-tight mb-5" style={{
            fontSize: "18px"
          }}>
              Digitales Büro
              <br />
              Oldenburg, Deutschland 26121
            </p>
            <div className="mb-5" style={{
            width: "24px",
            height: "1px",
            backgroundColor: "var(--primary)"
          }} />
            <p className="font-serif mb-6 leading-relaxed" style={{
            color: "var(--muted-foreground)",
            fontSize: "15px"
          }}>
              TERMINE NACH VEREINBARUNG — MO–FR 09:00–17:00
            </p>
            <Link to="/ContactPage" className="inline-flex items-center gap-2 font-mono uppercase tracking-[0.15em] underline underline-offset-4 hover:opacity-80 transition-opacity" style={{
            color: "var(--primary)",
            fontSize: "12px"
          }}>
              KONTAKT AUFNEHMEN →
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes chroma-pulse {
          0% {
            transform: scale(1);
            opacity: 0.9;
          }
          100% {
            transform: scale(3.5);
            opacity: 0;
          }
        }
        @keyframes chroma-scan {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </section>;
}